import { ActionTree } from 'vuex';
import { IRootState } from '@/store/types';
import { Note, NoteSort, NoteState } from './types';
import GET_LIST from './graphql/getList';
import DELETE_NOTE from './graphql/delete';
import UPDATE_NOTE from './graphql/update';

const actions: ActionTree<NoteState, IRootState> = {
  open({ commit, state, dispatch }) {
    // 小于等于的情况都打开时都尝试更新
    if (state.pageSize >= state.noteList.length) {
      commit('setEndCursor', '');
      dispatch('getList', true);
    }
    commit('open');
  },
  async getList({ commit, state, rootState }, reset: boolean) {
    if (!rootState.common.authingId || rootState.common.environment?.kind !== 'public-preview') {
      throw Error('未登录状态');
    }
    const res = await window.$getClemanClient().apollo.query({
      query: GET_LIST,
      variables: {
        courseId: rootState.common.environment.sharedKey,
        pageSize: state.pageSize,
        cursor: state.endCursor,
        sort: state.sort
      }
    });
    const courseNote = res.data.courseLearningNotesConnected;
    commit('setEndCursor', courseNote.endCursor);
    reset ? commit('setNoteList', courseNote.list) : commit('updateNoteList', courseNote.list);
    commit('setTotalCount', courseNote.totalCount);
    commit('setHasNext', courseNote.hasNext);
  },
  async resetList({ commit, dispatch }) {
    // 清空页数 从头查询
    commit('setEndCursor', '');
    commit('setScrollTop', true);
    await dispatch('getList', true);
  },
  async updateNote({ commit, dispatch }, note: Note) {
    await window.$getClemanClient().apollo.query({
      query: UPDATE_NOTE,
      variables: {
        id: note.id,
        update: {
          noteTitle: note.noteTitle,
          noteContent: note.noteContent,
          selectValue: note.selectValue
        }
      }
    });
    await dispatch('resetList');
  },
  async updateSort({ commit, dispatch }, sort: NoteSort) {
    commit('setSort', sort);
    await dispatch('resetList');
  },
  async deleteNote({ commit, state, rootState }, id: string) {
    await window.$getClemanClient().apollo.query({
      query: DELETE_NOTE,
      variables: {
        id
      }
    });
    commit('deleteNote', id);
  }
};
export default actions;
